import { render, staticRenderFns } from "./ModalEndereco.vue?vue&type=template&id=bdde19e4&scoped=true"
import script from "./ModalEndereco.vue?vue&type=script&lang=js"
export * from "./ModalEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdde19e4",
  null
  
)

export default component.exports